import getCookie from "./getCookie";
//eslint-disable-next-line
const mixpanel = __isBrowser__
  ? require("mixpanel-browser")
  : {
      track: () => {},
      init: () => {},
      people: { set: () => {}, increment: () => {} }
    };
mixpanel.init(process.env.MIXPANEL_TOKEN);

let Mixpanel = {
  identify: id => {
    mixpanel.identify(id);
  },
  alias: id => {
    mixpanel.alias(id);
  },
  track: (name, props) => {
    //eslint-disable-next-line
    if (__isBrowser__) {
      const deviceId = getCookie("device-id");
      const token = getCookie("auth-token");
      const location = window.location;
      const isRestaurantRoute =
        location.pathname.includes("/restaurants/") ||
        location.pathname.includes("/restaurant/");
      if (token || isRestaurantRoute) {
        Mixpanel.identify(deviceId);
        mixpanel.register({ Platform: "Web" });
        mixpanel.track(name, props);
      }
    }
  },
  people: {
    set: props => {
      //eslint-disable-next-line
      if (__isBrowser__) {
        const deviceId = getCookie("device-id");
        const token = getCookie("auth-token");
        const location = window.location;
        const isRestaurantRoute =
          location.pathname.includes("/restaurants/") ||
          location.pathname.includes("/restaurant/");
        if (token || isRestaurantRoute) {
          Mixpanel.identify(deviceId);
          mixpanel.people.set({ "Device Id": deviceId });
          mixpanel.register({ Platform: "Web" });
          mixpanel.people.set(props);
        }
      }
    },
    increment: (name, props) => {
      //eslint-disable-next-line
      if (__isBrowser__) {
        const deviceId = getCookie("device-id");
        const token = getCookie("auth-token");
        const location = window.location;
        const isRestaurantRoute =
          location.pathname.includes("/restaurants/") ||
          location.pathname.includes("/restaurant/");
        if (token || isRestaurantRoute) {
          Mixpanel.identify(deviceId);
          mixpanel.register({ Platform: "Web" });
          mixpanel.people.increment(name, props);
        }
      }
    }
  }
};

export default Mixpanel;
